import Searchbox from '@bingads-webui-campaign-legacy/auto-targets/view/category-targets/searchBoxWithAutoSuggestion';

export default (definePlugin) => {
  return definePlugin('autoSuggestionSearchBox', ['config', 'projection'], (config, projection) => {
    const searchbox = new Searchbox({
      el: config.pluginsConfig.autoSuggestionSearchBox.el,
      dataSource: config.pluginsConfig.autoSuggestionSearchBox.dataSource,
    });

    searchbox.on('search', (value) => {
      if (value) {
        projection.set('filter', {
          $or: [
            {
              CategoryName: {
                $startswith: value,
              },
            },
            {
              CategoryName: {
                $contains: `/${value}`,
              },
            },
          ],
        });
      } else {
        projection.set({'filter': {}, 'page.number': 0 });
      }
    });

    return searchbox;
  });
};
